<template>
  <!--我的收藏页面-->
  <tk-container
    :status="status"
    infiniteScroll
    @refresh="refreshInit"
    ref="resetMyCollection"
    @loadingMore="recommendedProducts"
  >
    <!--头部-->
    <my-header slot="header" :border-show="true">我的收藏</my-header>
    <!--收藏的商品列表-->
    <div class="bg-white p-y-5">
      <div v-if="commodity.length">
        <div
          class="m-x-12"
          v-for="(s, index) in commodity"
          :key="index"
        >
          <commodity-single
            :commodity="s"
            :image-size="108"
            :offer-show="false"
          >
          </commodity-single>
          <div class="m-y-5"
               v-if="index < (commodity.length - 1)"
               style="width: 100%;height: 1px;background: #f5f5f5;"></div>
        </div>
      </div>
      <empty-tips v-else :width="100" :height="100" :empty-msg="'暂无数据'"></empty-tips>
    </div>
    <!--为你推荐-->
    <infinite-list :title="'为你推荐'" :infinite-list-pad="'p-x-12'" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#000000'"></infinite-list>
  </tk-container>
</template>

<script>
import { priceProcessing } from '@/assets/help/tool'
import commoditySingle from '@/components/commoditySingle'
export default {
  components: {
    commoditySingle
  },
  data () {
    return {
      status: 'loading', // 页面状态
      timeRule: null, // 限时抢购时间
      commodity: [], // 收藏的商品
      recommendedProductsData: [] // 为你推荐商品数据获取
    }
  },
  computed: {
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  activated () {
    this.getInit()
  },
  methods: {
    /**
    * 页面初始化
    * @date: 2020/4/14
    */
    async getInit () {
      try {
        this.setStatusBar('dark')
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getCollectionProduct() // 获取收藏商品列表
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetMyCollection.resetInfiniteScroll()
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let timeRule = await this.$tkParse.getList(`/classes/timeRule`, {
        params: {
          limit: 1,
          where: {
            startTime: {
              $lte: {
                '__type': 'Date',
                'iso': isoStartDate
              }
            }
          }
        }
      })
      if (timeRule.length) { this.timeRule = timeRule[0] } else { this.timeRule = null }
    },
    /**
    * 获取收藏商品列表
    * @date: 2020/4/14
    */
    async getCollectionProduct () {
      let res = await this.$tkParse.getList('/classes/commodity', {
        params: {
          limit: 10000,
          where: {
            collection: {
              $all: [this.userInfo.objectId]
            }
          }
        }
      })
      if (res.length) { this.commodity = priceProcessing(res, this.judgeTimeRule) } else { this.commodity = [] }
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/3/24
     */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
